// @flow
// Constants
import {
  UTM_PARAMS,
  VISITOR_LOG_EXPIRES_AT_KEY,
  VISITOR_LOG_EXPIRATION_DAYS,
  VISITOR_LOG_KEYS,
} from '../constants';
//Types
import type { VisitorLogUtmPayload } from '../types/VisitorLog';

export const buildUtmPayload = (
  search: string,
): VisitorLogUtmPayload | null => {
  const params = new URLSearchParams(search);
  if (!UTM_PARAMS.some(p => params.has(p))) return null;
  return {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_content: params.get('utm_content'),
    utm_campaign: params.get('utm_campaign'),
  };
};

export const clearVisitorLogStorage = () => {
  VISITOR_LOG_KEYS.forEach(key => localStorage.removeItem(key));
};

const isVisitorLogStorageExpired = (): boolean => {
  const expiresAt = Number(localStorage.getItem(VISITOR_LOG_EXPIRES_AT_KEY));

  return !!expiresAt && Date.now() > expiresAt;
};

export const getVisitorLogItem = (key: string): ?string => {
  if (isVisitorLogStorageExpired()) {
    clearVisitorLogStorage();
    return null;
  }

  return localStorage.getItem(key);
};

export const setVisitorLogItem = (key: string, value: string) => {
  if (isVisitorLogStorageExpired()) {
    clearVisitorLogStorage();
  }

  if (!localStorage.getItem(VISITOR_LOG_EXPIRES_AT_KEY)) {
    const expiresAt =
      Date.now() + VISITOR_LOG_EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(VISITOR_LOG_EXPIRES_AT_KEY, String(expiresAt));
  }

  localStorage.setItem(key, value);
};
